import React from "react";

import { wrap } from "./RydTestbedWrap";
import { RydProject } from "../model/project";
import { ComputedContextFrame, ContextFrame } from "../model/context";
import { RydMidiLoadDialog } from "../components/dialogs/RydMidiLoadDialog";


export function MidiLoaderTestbed() {

    const [project, setProject] = React.useState<RydProject | null>(null);

    const contextFrame = new ComputedContextFrame();
    // if (data) {
    //     console.log("Setting context frame with HNC data", project);
    //     contextFrame.timeSignature = data.ts;
    //     contextFrame.metronome = data.bpm;
    // }

    return wrap(<>
        {/* Add your testbed components here */}
        <h1>MidiLoader Testbed</h1>
        <RydMidiLoadDialog setProject={setProject} />

        {/* {project &&
            <>
                <MetronomeInputBox
                    metronome={data.bpm}
                />

                <PianoRoll
                    readonly={false}
                    hnc={data.hnc}
                    contextFrame={contextFrame}
                    showSheet={false}
                    name={"Testbed Piano Roll"}

                />
            </>
        } */}
    </>);
}